// src/FramerWorks.js
import React from "react";
import { IonIcon } from "@ionic/react";
import { openOutline } from "ionicons/icons";

const FRAMER_PROFILE = "https://www.framer.com/@gazi-efe/";

const framerItems = [
  {
    id: "kestral",
    name: "Kestral",
    type: "template",
    price: "$49",
    isFree: false,
    link: "https://www.framer.com/marketplace/template/kestral/",
    description: "A premium dark-themed agency template with smooth animations and modern layouts.",
    gradient: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
    icon: "🚀",
  },
  {
    id: "magnet-button",
    name: "Magnet Button",
    type: "component",
    price: "Free",
    isFree: true,
    link: "https://www.framer.com/marketplace/components/magnet-button/",
    description: "A magnetic button that follows your cursor with smooth attraction physics.",
    gradient: "linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 50%, #2a2a2a 100%)",
    icon: "🧲",
  },
  {
    id: "spectrum-button",
    name: "Spectrum Button",
    type: "component",
    price: "Free",
    isFree: true,
    link: "https://www.framer.com/marketplace/components/spectrum-button/",
    description: "An animated gradient border button with a sleek spectrum color effect.",
    gradient: "linear-gradient(135deg, #1a1a1a 0%, #2d1b3d 50%, #1a1a2e 100%)",
    icon: "🌈",
  },
  {
    id: "3d-coverflow",
    name: "3D Coverflow",
    type: "component",
    price: "$3",
    isFree: false,
    link: "https://www.framer.com/marketplace/components/3d-coverflow/",
    description: "A stunning 3D carousel with perspective transforms and smooth transitions.",
    gradient: "linear-gradient(135deg, #2d1b1b 0%, #1a1a1a 50%, #1b2d1b 100%)",
    icon: "🎴",
  },
  {
    id: "velocity-marquee",
    name: "Velocity Marquee",
    type: "component",
    price: "$3",
    isFree: false,
    link: "https://www.framer.com/marketplace/components/velocity-marquee/",
    description: "A scroll-velocity based marquee that speeds up as you scroll. Infinite loop logos.",
    gradient: "linear-gradient(135deg, #1a1a1a 0%, #1e1e1e 50%, #252525 100%)",
    icon: "⚡",
  },
  {
    id: "scramble-lens",
    name: "Scramble Lens",
    type: "component",
    price: "Free",
    isFree: true,
    link: "https://www.framer.com/marketplace/components/scramble-lens/",
    description: "Text scramble animation that decodes characters on hover or scroll into view.",
    gradient: "linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 50%, #1a1a1a 100%)",
    icon: "🔤",
  },
  {
    id: "hover-reveal-grid",
    name: "Hover Reveal Grid",
    type: "component",
    price: "$2",
    isFree: false,
    link: "https://www.framer.com/marketplace/components/hover-reveal-grid/",
    description: "An image grid with beautiful hover reveal effects and smooth transitions.",
    gradient: "linear-gradient(135deg, #1b2d1b 0%, #1a2e1a 50%, #1a1a1a 100%)",
    icon: "🖼️",
  },
  {
    id: "pricing-pulse",
    name: "Pricing Pulse",
    type: "component",
    price: "$2",
    isFree: false,
    link: "https://www.framer.com/marketplace/components/pricing-pulse/",
    description: "An interactive pricing card with pulse animations and a sleek slider control.",
    gradient: "linear-gradient(135deg, #1a1a1a 0%, #1e1b2d 50%, #1a1a2e 100%)",
    icon: "💰",
  },
  {
    id: "plan-compare",
    name: "Plan Compare",
    type: "component",
    price: "Free",
    isFree: true,
    link: "https://www.framer.com/marketplace/components/plan-compare/",
    description: "A clean plan comparison table with toggle and feature highlighting.",
    gradient: "linear-gradient(135deg, #1a1a1a 0%, #1a1e2d 50%, #0f0f1e 100%)",
    icon: "📊",
  },
];

const FramerWorks = () => {
  const template = framerItems.find((item) => item.type === "template");
  const components = framerItems.filter((item) => item.type === "component");

  return (
    <div className="framer-works-content">
      {/* Featured Template */}
      <div className="framer-featured reveal">
        <div className="framer-featured-label">
          <span className="framer-featured-dot">★</span>
          Featured Template
        </div>
        <a
          href={template.link}
          target="_blank"
          rel="noopener noreferrer"
          className="framer-template-card"
        >
          <div
            className="framer-template-preview"
            style={{ background: template.gradient }}
          >
            <div className="framer-template-preview-inner">
              <div className="framer-template-mockup">
                <div className="framer-mockup-bar">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="framer-mockup-content">
                  <div className="framer-mockup-nav"></div>
                  <div className="framer-mockup-hero">
                    <div className="framer-mockup-title"></div>
                    <div className="framer-mockup-subtitle"></div>
                    <div className="framer-mockup-btn"></div>
                  </div>
                  <div className="framer-mockup-grid">
                    <div className="framer-mockup-card"></div>
                    <div className="framer-mockup-card"></div>
                    <div className="framer-mockup-card"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-template-info">
            <div className="framer-template-meta">
              <h3 className="framer-card-name">{template.name}</h3>
              <span className="framer-price-badge framer-price-paid">
                {template.price}
              </span>
            </div>
            <p className="framer-card-desc">{template.description}</p>
            <div className="framer-card-action">
              <span className="framer-view-btn">
                View on Framer
                <IonIcon icon={openOutline} className="framer-btn-icon" />
              </span>
            </div>
          </div>
        </a>
      </div>

      {/* Components Grid */}
      <div className="framer-components-header reveal">
        <h3 className="framer-components-title">Components</h3>
        <span className="framer-components-count">{components.length} items</span>
      </div>

      <div className="framer-grid reveal">
        {components.map((item) => (
          <a
            key={item.id}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="framer-card"
          >
            <div
              className="framer-card-preview"
              style={{ background: item.gradient }}
            >
              <div className="framer-card-preview-content">
                <span className="framer-card-emoji">{item.icon}</span>
              </div>
              <span
                className={`framer-price-float ${
                  item.isFree ? "framer-price-free" : "framer-price-paid"
                }`}
              >
                {item.price}
              </span>
            </div>
            <div className="framer-card-body">
              <h4 className="framer-card-name">{item.name}</h4>
              <p className="framer-card-desc">{item.description}</p>
            </div>
          </a>
        ))}
      </div>

      {/* CTA to Framer profile */}
      <div className="framer-cta reveal">
        <a
          href={FRAMER_PROFILE}
          target="_blank"
          rel="noopener noreferrer"
          className="framer-profile-link"
        >
          View all on Framer
          <svg
            width="14"
            height="14"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M3 8h10M9 4l4 4-4 4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default FramerWorks;
